import { render } from "./realNameWait.vue?vue&type=template&id=721196c6&scoped=true"
import script from "./realNameWait.vue?vue&type=script&lang=js"
export * from "./realNameWait.vue?vue&type=script&lang=js"

import "./realNameWait.vue?vue&type=style&index=0&id=721196c6&lang=scss&scoped=true"

import exportComponent from "/root/workspace/zyy-iot_zyy-iot-web-v2_ZubV/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-721196c6"]])

export default __exports__